export class Input {
  readonly keys = new Set<string>();
  dx = 0;
  dy = 0;
  wheel = 0;
  left = false;
  right = false;
  leftDown = false;
  rightDown = false;
  pointerLocked = false;

  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
    window.addEventListener("mousemove", this.onMove);
    window.addEventListener("mousedown", this.onDown);
    window.addEventListener("mouseup", this.onUp);
    window.addEventListener("wheel", this.onWheel, { passive: true });
    document.addEventListener("pointerlockchange", this.onLock);
    window.addEventListener("blur", this.onBlur);
    el.addEventListener("contextmenu", (e) => e.preventDefault());
  }

  dispose(): void {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
    window.removeEventListener("mousemove", this.onMove);
    window.removeEventListener("mousedown", this.onDown);
    window.removeEventListener("mouseup", this.onUp);
    window.removeEventListener("wheel", this.onWheel);
    document.removeEventListener("pointerlockchange", this.onLock);
    window.removeEventListener("blur", this.onBlur);
  }

  consumeLook(): { dx: number; dy: number } {
    const v = { dx: this.dx, dy: this.dy };
    this.dx = 0;
    this.dy = 0;
    return v;
  }

  consumeWheel(): number {
    const w = this.wheel;
    this.wheel = 0;
    return w;
  }

  consumeClicks(): { left: boolean; right: boolean } {
    const v = { left: this.leftDown, right: this.rightDown };
    this.leftDown = false;
    this.rightDown = false;
    return v;
  }

  pressed(code: string): boolean {
    return this.keys.has(code);
  }

  lock(): void {
    this.el.requestPointerLock();
  }

  unlock(): void {
    document.exitPointerLock();
  }

  private onKeyDown = (e: KeyboardEvent): void => {
    if (e.repeat) {
      this.keys.add(e.code);
      return;
    }
    this.keys.add(e.code);
    if (["Space", "KeyF", "KeyE", "Tab"].includes(e.code)) e.preventDefault();
  };

  private onKeyUp = (e: KeyboardEvent): void => {
    this.keys.delete(e.code);
  };

  private onMove = (e: MouseEvent): void => {
    if (!this.pointerLocked) return;
    this.dx += e.movementX;
    this.dy += e.movementY;
  };

  private onDown = (e: MouseEvent): void => {
    if (e.button === 0) {
      this.left = true;
      this.leftDown = true;
    }
    if (e.button === 2) {
      this.right = true;
      this.rightDown = true;
    }
  };

  private onUp = (e: MouseEvent): void => {
    if (e.button === 0) this.left = false;
    if (e.button === 2) this.right = false;
  };

  private onWheel = (e: WheelEvent): void => {
    this.wheel += Math.sign(e.deltaY);
  };

  private onLock = (): void => {
    this.pointerLocked = document.pointerLockElement === this.el;
  };

  private onBlur = (): void => {
    this.keys.clear();
    this.left = false;
    this.right = false;
  };
}
